import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { appHeightChanged } from '../../actions/app-actions'
import Profile from './Profile'

class ProfileState extends React.Component {
    constructor() {
        super();


    }
    componentDidMount() {
        const { actions, movies, organizerIds, iframeId } = this.props
        if (window.parent != window) actions.appHeightChanged(iframeId, true);
        else window.scrollTo(0, 0);
        // if (window.parent != window) actions.appHeightChanged(iframeId, true, false, true);
      
    }

   

    render() {
        const { iframeId } = this.props
        console.log(iframeId,'profile state')
        return (
            <Profile iframeId={iframeId} />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
   

    return {
        iframeId: state.app.iframeId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { appHeightChanged,  }), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileState)